import Vue from "vue";
import { Pagination, Dialog, Menu, MenuItem, Submenu, Row, Col, PageHeader, Tabs, Tree, TabPane, Form, FormItem, Input, Radio, RadioGroup, Switch, Select, Option, Button, Table, TableColumn, Loading, MessageBox, Message, Image, Checkbox, CheckboxButton, CheckboxGroup, DatePicker, Link, Upload, Card, Breadcrumb, BreadcrumbItem } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Utils from "./utils";
import JsonExcel from "vue-json-excel";
import Print from "vue-print-nb";
import ElementUI from "element-ui"; // 引入 Element UI
import "element-ui/lib/theme-chalk/index.css"; // 引入 Element UI 的样式
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.component("downloadExcel", JsonExcel);

Vue.config.productionTip = false;

Vue.use(Dialog);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(Row);
Vue.use(Col);
Vue.use(Pagination);
Vue.use(PageHeader);

Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);

Vue.use(Input);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(Image);
Vue.use(DatePicker);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Link);
Vue.use(Upload);
Vue.use(Tree);
Vue.use(Card);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Print);
Vue.use(ElementUI);
Vue.use(Loading.directive);
Vue.use(Viewer);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
Vue.prototype.$utils = Utils;
Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1, //month
    "d+": this.getDate(), //day
    "h+": this.getHours(), //hour
    "m+": this.getMinutes(), //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
    "S": this.getMilliseconds(), //millisecond
  };

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (o.hasOwnProperty(k)) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
  }
  return format;
};

// directives.js
const longpress = {
  bind(el, binding, vNode) {
    let pressTimer = null;
    let isLongPress = false;

    el.addEventListener("mousedown", e => {
      if (e.button !== 0) {
        return;
      }
      pressTimer = setTimeout(() => {
        isLongPress = false;
        handler(e);
      }, 300);

      const handler = e => {
        if (!binding.modifiers.prevent) {
          e.preventDefault();
        }
        if (binding.value) {
          binding.value(e);
        }
        isLongPress = true;
      };
    });

    el.addEventListener("mouseup", e => {
      if (e.button !== 0) {
        return;
      }

      if (pressTimer) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }

      if (isLongPress) {
        if (!binding.modifiers.prevent) {
          e.preventDefault();
        }
        if (binding.value) {
          binding.value(e);
        }
        isLongPress = false;
      }
    });

    el.addEventListener("click", e => {
      if (pressTimer) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    });

    el.addEventListener("mouseout", e => {
      if (pressTimer) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    });
  },
};
Vue.directive("longpress", longpress);

import permDirective from "./utils/permDirective";
import { hasPerm, hasRole } from "./utils/permission";
Vue.directive("perm", permDirective);
Vue.prototype.$hasPerm = hasPerm;
Vue.prototype.$hasRole = hasRole;

Vue.prototype.$eventBus = new Vue();

import { getAuthToken, setAuthToken } from "./utils/auth";
import { mountDynamicRoutes } from "./router";

async function bootstrap() {
  // 冷启动:如果本地有 token,先同步一次 perms + menuTree,再 addRoute,再挂 Vue。
  // 这样进 App 时权限已经就绪,顶栏 / 左栏、按钮级 v-perm 都不会闪。
  const token = getAuthToken();
  if (token) {
    // localStorage survives a browser restart, while the satoken Cookie may not. Restore it so
    // native uploads/downloads and other requests that bypass Axios still carry authentication.
    setAuthToken(token);
    try {
      await store.dispatch("user/loadMenus");
      mountDynamicRoutes();
    } catch (e) {
      // 拉失败通常是 token 过期,router beforeEach 会把用户送回登录页。
      console.warn("[bootstrap] loadMenus failed:", e);
    }
  }

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount("#app");

  // 权限就绪、Vue 挂载完成后收尾页面加载动画（ly-loader）。
  // 加载动画由 public/js/ly-loader.js 在 index.html 里提前挂载。
  if (window.LYLoader && typeof window.LYLoader.hide === "function") {
    window.LYLoader.hide();
  }
}

bootstrap();
